// @flow
export const DROPDOWN_THEME_API = {
  dropdown: '',
  label: '',
};
